/* unplugin-vue-components disabled */import i18n from '@/lang';
import "core-js/modules/es.array.join.js";
/* this file is transformed by vux-loader */
/* eslint-disable */
import _objectSpread from "G:/SVN/\u5355\u5C0F\u4E8C/\u6E90\u4EE3\u7801/\u5BA2\u6237\u7AEF\u95E8\u6237/front/smy-toc-vux-cli3/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "core-js/modules/es.array.join.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import ViewBox from "vux/src/components/view-box/index.vue"; // this line is trasformed by vux-loader
import XButton from "vux/src/components/x-button/index.vue"; // this line is trasformed by vux-loader
import XTextarea from "vux/src/components/x-textarea/index.vue"; // this line is trasformed by vux-loader
import Group from "vux/src/components/group/index.vue"; // this line is trasformed by vux-loader
import GroupTitle from "vux/src/components/group-title/index.vue"; // this line is trasformed by vux-loader
import SmyFullPopup from '@/components/SmyFullPopup';
import ImgUpload from '@/components/ImgUpload';
import FileUpload from '@/components/FileUpload';
import { apimessage } from '@/api';
var form = {
  message: '',
  imgList: [],
  attachmentList: [],
  isCustomerView: true
};
export default {
  name: 'message',
  components: {
    ViewBox: ViewBox,
    XButton: XButton,
    XTextarea: XTextarea,
    Group: Group,
    GroupTitle: GroupTitle,
    ImgUpload: ImgUpload,
    SmyFullPopup: SmyFullPopup,
    FileUpload: FileUpload
  },
  props: {
    value: {
      type: Boolean
    },
    id: {
      require: true
    }
  },
  watch: {
    value: function value(v) {
      this.isShow = v;
      this.form = _objectSpread({}, form);
    },
    isShow: function isShow(v) {
      this.$emit('input', v);
    }
  },
  data: function data() {
    return {
      loading: false,
      list: [],
      isShow: false,
      form: _objectSpread({}, form)
    };
  },
  methods: {
    submit: function submit() {
      var _this = this;
      this.loading = true;
      if (!this.form.message) {
        this.$vux.toast.text(i18n.tc("583"));
        this.loading = false;
        return;
      }
      var parmas = {
        content: this.form.message,
        images: this.form.imgList.join(','),
        file_url: this.form.attachmentList.join(','),
        is_view: this.form.isCustomerView ? 0 : 1,
        project_id: this.id
      };
      apimessage(parmas, 'post').then(function (res) {
        _this.loading = false;
        if (res.success) {
          _this.$vux.toast.text(i18n.tc("338"));
          _this.isShow = false;
          _this.$emit('callback');
        } else {
          _this.$vux.toast.text(res.message);
        }
      });
    }
  }
};